import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Lightning, Trophy } from "@phosphor-icons/react";
import { LevelPips, levelOf } from "@/pages/gami/shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GamificationBadge() {
  const { t } = useTranslation();
  const [me, setMe] = useState(null);

  useEffect(() => {
    let active = true;
    const load = () => axios.get(`${API}/gamification/me`, { withCredentials: true })
      .then(r => { if (active) setMe(r.data); }).catch(() => {});
    load();
    window.addEventListener("gami:refresh", load);
    return () => { active = false; window.removeEventListener("gami:refresh", load); };
  }, []);

  if (!me) return null;

  if (!me.eligible) {
    return (
      <Link to="/ranking" data-testid="ranking-link"
            className="flex items-center justify-center gap-2 px-3 py-2 rounded-sm border border-zinc-800 text-slate-300 hover:bg-zinc-800 text-xs uppercase tracking-wider font-bold transition-colors">
        <Trophy size={14} className="text-amber-400" weight="fill" /> {t("gami.ranking")}
      </Link>
    );
  }

  return (
    <Link to="/ranking" data-testid="gamification-badge"
          className="flex items-center gap-2 px-3 py-2 rounded-sm bg-zinc-950 border border-zinc-800 hover:border-[var(--brand,#E31E24)] transition-colors">
      <div className="flex items-center gap-1 text-[var(--brand,#E31E24)] font-black tabular-nums">
        <Lightning size={16} weight="fill" /> {me.points}
      </div>
      <div className="flex-1 min-w-0"><LevelPips stars={me.stars} size={9} /></div>
      <span className="text-[9px] uppercase tracking-wide font-bold truncate" style={{ color: levelOf(me.level_name).color }}
            data-testid="gamification-badge-level">{t(`gami.levels.${me.level_name}`, { defaultValue: me.level_name })}</span>
    </Link>
  );
}
